import React from "react";

/**
 * Step one: confirm the company and sector an analysis will run for.
 *
 * @param {object} props - Prefill, current selections, and handlers.
 * @returns {JSX.Element} The setup card.
 *
 * @remarks
 * Both fields are prefilled from the account but stay editable, because an
 * analyst may be preparing a comparison for a subsidiary rather than the
 * registered entity.
 */
const AnalyzeCompanyCard = ({
  context,
  sectorName,
  baseCompanyName,
  onSectorChange,
  onCompanyChange,
  onGetCompetitors,
  busy,
}) => (
  <section className="aica-card">
    <div className="aica-card-head">
      <div>
        <h2>Step 1 &middot; Confirm company &amp; sector</h2>
        <p className="aica-sub">
          Logged in as <strong>{context.baseCompanyName}</strong> — company and
          sector are identified from your account.
        </p>
      </div>
    </div>

    <div className="aica-form-row">
      <div className="aica-field">
        <label className="aica-label" htmlFor="aica-company">
          1 &middot; Base company
        </label>
        <input
          id="aica-company"
          type="text"
          value={baseCompanyName}
          onChange={(event) => onCompanyChange(event.target.value)}
        />
      </div>

      <div className="aica-field">
        <label className="aica-label" htmlFor="aica-sector">
          2 &middot; Sector
        </label>
        <select
          id="aica-sector"
          value={sectorName}
          onChange={(event) => onSectorChange(event.target.value)}
        >
          {!context.sectorName && <option value="">Select a sector</option>}
          {context.sectors.map((sector) => (
            <option key={sector.id} value={sector.name}>
              {sector.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <button
          type="button"
          className="aica-btn aica-btn-primary"
          onClick={onGetCompetitors}
          disabled={busy || !sectorName || !baseCompanyName}
        >
          {busy ? "Identifying competitors…" : "Get competitors"}
        </button>
      </div>
    </div>

    {context.sectorName ? (
      <div className="aica-note">
        Identified from your NetZhero account — change either field if this
        analysis is for a different company.
      </div>
    ) : (
      <div className="aica-note aica-note-warn">
        Your account has no sector recorded. Choose one to continue.
      </div>
    )}
  </section>
);

export default AnalyzeCompanyCard;
